import React from "react";
import * as S from "./style";
import DefaultUserImg from "../../Assets/Images/user-profile.png";
import { MdVerified } from "react-icons/md";
import { PiCrownSimpleLight } from "react-icons/pi";
import { ExploreList } from "../../Config/interface.config";
import { Capitalize, getCreatorProfilePath } from "../../Utils";
import { DEFAULT_PRICING } from "../../Config/common.config";
import { useNavigate } from "react-router-dom";
import { ProtectedImage } from "../ProtectedMedia";

interface Props {
  creator: ExploreList;
  subscribeCreator: (creator: ExploreList) => void;
}

const Suggesstion: React.FC<Props> = ({ creator, subscribeCreator }: Props) => {
  const navigate = useNavigate();

  const showProfile = (username: string) => {
    if (username) {
      navigate(getCreatorProfilePath(username));
    }
  };

  return (
    <S.SuggestionBox className="text-white">
      <ProtectedImage
        as={S.ProfileImage}
        onClick={() => showProfile(creator.username)}
        url={creator?.image?.fileURL}
        fallbackSrc={DefaultUserImg}
        alt=""
      />
      <S.SugestionDetails onClick={() => showProfile(creator.username)}>
        <S.Username>
          {Capitalize(creator?.fullname)}
          <MdVerified />
        </S.Username>
        <S.EmailAddress>@{creator?.username}</S.EmailAddress>
      </S.SugestionDetails>

      <S.JoinBtn
        className="!hidden sm:!flex"
        onClick={() => subscribeCreator(creator)}
      >
        <PiCrownSimpleLight size={20} strokeWidth={"10px"} />
        Join For ₹{creator?.membership?.monthlyPrice ?? DEFAULT_PRICING}
      </S.JoinBtn>
      <S.JoinBtn
        className="!flex sm:!hidden"
        onClick={() => subscribeCreator(creator)}
      >
        <PiCrownSimpleLight size={20} strokeWidth={"10px"} />
        Join
      </S.JoinBtn>
    </S.SuggestionBox>
  );
};

export default Suggesstion;
